/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {DestinoListComponent} from "./destino-list/destino-list.component";
import {DestinoFormComponent} from "./destino-form/destino-form.component";
import {editRoute, newRoute, configuracaoRoute} from "../../shared/services/data.service";
import {viagensRoute} from "../shared/data.service";
import {destinosRoute} from "./shared/data.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class DestinosRoutingModule {}

export const destinosRoutes: any[] = [
    {
        path: '',
        component: DestinoListComponent
    },{
        path: editRoute + '/:id',
        component: DestinoFormComponent
    },{
        path: newRoute,
        component: DestinoFormComponent
    }

];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/destinos-routing.module.ts
 **/